import { FLOW_ID_KEY } from './useAdSubmissionFlow.constants';

export const setFlowId = (flowId: string) => {
  sessionStorage.setItem(FLOW_ID_KEY, flowId);
};

export const getFlowId = () => {
  return sessionStorage.getItem(FLOW_ID_KEY);
};

export const removeFlowId = () => {
  sessionStorage.removeItem(FLOW_ID_KEY);
};
